import * as THREE from 'three';
import {
    OrbitControls
} from 'three/examples/jsm/controls/OrbitControls.js';
import './style.css';

const canvas = document.querySelector('canvas.webgl')
const scene = new THREE.Scene();
const textureLoader = new THREE.TextureLoader();
const seaColorTexture = textureLoader.load('color.png');
const seaHeightTexture = textureLoader.load('height.png');

const material = new THREE.MeshStandardMaterial();
material.roughness = 1;
material.metalness = 0;
material.displacementMap = seaHeightTexture;
material.map = seaColorTexture;
material.side = THREE.DoubleSide;
material.wireframe = true;
material.displacementScale = 0.05;

navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    })
    .then(stream => {
        const audioContext = new AudioContext();
        const mediaStreamAudioSourceNode = audioContext.createMediaStreamSource(stream);
        const analyserNode = audioContext.createAnalyser();
        mediaStreamAudioSourceNode.connect(analyserNode);
        const pcmData = new Float32Array(analyserNode.fftSize);

        const onFrame = () => {
            analyserNode.getFloatTimeDomainData(pcmData);
            let sumSquares = 0.0;
            for (const amplitude of pcmData) {
                sumSquares += amplitude * amplitude;
            }
            material.displacementScale = Math.sqrt(sumSquares / pcmData.length) * 2;
            window.requestAnimationFrame(onFrame);
        };

        window.requestAnimationFrame(onFrame);

        console.log(`
               !YJ^         ^^7^
                ^? 7^~^     !G7            ^7J~
 57!~^^~!777!^   ~&@&@5   ~G ~        ^^7G&&@@5
J@@@@@@@@&@@@@#5~^G@@ !   ^5#~ ~?JYYJP7.?@@@@#^
7@@@@@@@~  GGG@@@#&@#       ~~J@@@@ ~P~  #@@@7
 ~7~#@@@#~ 7! ~@@@@G77~     7&@@@@G  5  5@@#7
      @@@@@@@@@@@@@&&#!     5@@@@& PPGY5GY~
      ~J5PJ!75#&&G7J?       ^ @ !
               ^^
`);
    })
    .catch(() => console.error(`
               !YJ^         ^^7^
                ^? 7^~^     !G7            ^7J~
 57!~^^~!777!^   ~&@&@5   ~G ~        ^^7G&&@@5
J@@@@@@@@&@@@@#5~^G@@ !   ^5#~ ~?JYYJP7.?@@@@#^
7@@@@@@@~  GGG@@@#&@#       ~~J@@@@ ~P~  #@@@7
 ~7~#@@@#~ 7! ~@@@@G77~     7&@@@@G  5  5@@#7
      @@@@@@@@@@@@@&&#!     5@@@@& PPGY5GY~
      ~J5PJ!75#&&G7J?       ^ @ !
               ^^
`));

const plane = new THREE.Mesh(new THREE.PlaneBufferGeometry(1, 1, 1000, 1000), material);

const ambientLight = new THREE.AmbientLight(0xffffff, 1)

scene.add(plane);
scene.add(ambientLight)

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 0
camera.position.y = 0
camera.position.z = 1
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
});

const tick = () => {
    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
};

tick();